import React, {useEffect, useRef, useState, useMemo} from "react";
import { ProductTile } from "@project-stories/ecommerce/Product/ProductTile";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { mobileBreakpoint } from "../../../../entrypoints/theme";

export const RecommendedProducts = React.memo(({ products, settings }) => {
    const isMobile = useMobileBreakpoint(mobileBreakpoint);
    const carouselRecommendedListRef:any = useRef(null);

    useEffect(() => {
            // Prevents re-initialization
            const timeout = setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
            }, 2000);

            function resizeCarousel() {
            document.querySelectorAll(".carousel-recommended").forEach((carousel) => {
                const flickityCarousel = window.Flickity?.data(carousel);
                if (flickityCarousel) {
                setTimeout(() => flickityCarousel.resize(), 200);
                }
            });
            }

            window.addEventListener("carousel-init", resizeCarousel);
            resizeCarousel();

            return () => {
            clearTimeout(timeout);
            window.removeEventListener("carousel-init", resizeCarousel);
            };
    }, []);

    settings.show_quickadd = settings.section.product_tile_quickadd_show;
    settings.show_price = settings.section.product_tile_price_show;
    settings.show_tags = settings.section.product_tile_tag_show;

    return (
        <div
            className="recommendedproducts__container carousel-recommended flex-col w-full max-w-max"
            data-flickity={`{` +
                `"freeScroll": ${settings.use_freescroll}, ` +
                `"wrapAround": true, ` +
                `"cellAlign": "left", ` +
                `"pageDots": ${settings.show_indicators}, ` +
                `"prevNextButtons": ${settings.show_navbuttons}, ` +
                `"groupCells": 1` +
                `}`}
            {...({
                "x-data": "carousel",
                "x-init": `$nextTick(() => { initialise(${settings.show_indicators}, ${settings.show_navbuttons}, ${settings.fade_edgeitems}, false, 0, 'multicolumn-carousel', true, ${settings.use_freescroll}) })`,
                "x-ref": "carousel",
            })}

            ref={carouselRecommendedListRef}
        >
                {products.map((product, index) => (
                    <div key={index} className="carousel-item w-full lg:w-[262px] p-[70px] lg:p-[16px]">
                        <ProductTile
                            product={product}
                            swatches={product.swatches}
                            siblings={undefined}
                            settings={settings}
                            enableWishlist={settings.section.product_tile_wishlist_show}
                        />
                    </div>
                ))}

        </div>
        );
});

export default RecommendedProducts;
